Service = App.loadClass 'core::Angular/Service'

class exports.VisualLayersService extends Service
    constructor: (@http, @rootScope, @q) ->
        undefined

    byField: (id, spp_id, year) =>
        @http.post 'backend/grower/layers/planting-rx/ng-visual-layers',
            fields_id: id
            spp_id: spp_id
            year: year

    combineLayers: (field_id, layers) =>
        @http.post 'backend/grower/layers/planting-rx/cross-crop',
            field_id: field_id
            layers: layers
        .then (response) =>
            if response.data.status?.type isnt 'success'
                return @q.reject(response.data)
            return response.data.data
